var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"text-light font-body bg-dark min-h-dvh",attrs:{"id":"app"}},[_c('NavigationHeader',{staticClass:"mx-auto"}),_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }